import { Directive, ElementRef, Input, inject } from '@angular/core';
import { IonRouterOutlet } from '@ionic/angular';

@Directive({
  selector: '[bpDisplayIfCanGoBack]',
  standalone: false
})
export class DisplayIfCanGoBackDirective {
  private el = inject(ElementRef);
  private routerOutlet = inject(IonRouterOutlet);

  @Input('bpDisplayIfCanGoBack') set display(v: boolean) {
    if (this.routerOutlet && this.routerOutlet.canGoBack()) {
      this.el.nativeElement.style.display = v ? 'inherit' : 'none';
    } else {
      this.el.nativeElement.style.display = v ? 'none' : 'inherit';
    }
  }
}
